const APP_LAYOUT_SCROLL_CONTAINER_SELECTOR = '[data-scroll-container="app-layout"]'
const COURSES_OVERVIEW_SCROLL_KEY = 'fitnesshub:courses-overview-scroll'

function getScrollContainer() {
  if (typeof document === 'undefined') {
    return null
  }

  return document.querySelector<HTMLElement>(APP_LAYOUT_SCROLL_CONTAINER_SELECTOR)
}

export function saveCoursesOverviewScrollTop() {
  const top = getScrollContainer()?.scrollTop ?? 0
  sessionStorage.setItem(COURSES_OVERVIEW_SCROLL_KEY, String(top))
}

export function restoreCoursesOverviewScrollTop() {
  const value = sessionStorage.getItem(COURSES_OVERVIEW_SCROLL_KEY)
  if (!value) {
    return
  }

  const top = Number(value)
  if (!Number.isFinite(top)) {
    sessionStorage.removeItem(COURSES_OVERVIEW_SCROLL_KEY)
    return
  }

  getScrollContainer()?.scrollTo({ top, behavior: 'auto' })
  sessionStorage.removeItem(COURSES_OVERVIEW_SCROLL_KEY)
}

export function scrollAppLayoutToTop() {
  getScrollContainer()?.scrollTo({ top: 0, behavior: 'auto' })
}
